import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Row, Col, Badge } from 'antd'
import { withTranslation } from 'react-i18next'
import { createBrowserHistory } from 'history';
import HomeIcon from '@material-ui/icons/Home';
import ChatIcon from '@material-ui/icons/Chat';
import OrderIcon from '@material-ui/icons/List';

const STAYCHAT_WS_URL = process.env.REACT_APP_STAYCHAT_WS;
const isDisableBot = process.env.REACT_APP_STAYCHAT_BOT_DISABLE !== "false";
let scws = null;
let scwsUser = '';

@inject(
    'templateStore',
    'webSettingStore',
    'translationStore',
    'chatStore'
)
@observer
class FooterMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.scwsConnect();
    }

    scwsConnect() {
        if (!STAYCHAT_WS_URL) return;

        this.props.chatStore.sync();

        const roomNo = JSON.parse(window.localStorage.getItem('roomNo'));
        const customerId = window.localStorage.getItem('customerId');
        scwsUser = `staymenu_${customerId}`;

        const token = window.btoa(scwsUser + ":" + roomNo);
        const url = `${STAYCHAT_WS_URL}?access_token=${token}`;
        scws = new WebSocket(url);

        scws.onopen = () => {
            console.log("StayChat WebSocket are opened");
            this.scwsHeartbeat();
        };

        scws.onmessage = (data) => {
            console.log("StayChat WebSocket message received");

            var obj = eval('(' + data.data + ')');

            if (!obj) {
                console.log("StayChat WebSocket message empty");
                return;
            }

            if (obj.Action === "heartbeat") {
                console.log("heartbeat");
                return;
            }

            if (obj.Action === "StayChatSync") {
                const history = createBrowserHistory();

                if (history.location.pathname.includes('chat')) {
                    if (obj.Data?.IsReplied) this.props.chatStore.setKeepLoading(false);
                    this.props.chatStore.reload();
                }
                else {
                    this.props.chatStore.sync();
                }
            }

            // Play audio if from ChatBot
            if (!isDisableBot && obj.Action === "SendMessage" && obj.Data && obj.Data.Sender === "ChatBot" && obj.Data.AudioUrl) {
                const player = new Audio(obj.Data.AudioUrl);
                player.play();
            }
        };

        scws.onclose = (code, reason) => {
            console.log("StayChat WebSocket are closed." + code.code + " Reason:" + reason);
            setTimeout(this.scwsHeartbeat, 3000);
        };

        scws.onerror = (err) => {
            console.error('StayChat WebSocket encountered error: ', err.message, 'Closing socket');
            scws.close();
        };

        this.scwsHeartbeat();
    }

    scwsHeartbeat() {
        if (!scws || scws.readyState !== 1) return;

        var obj = {
            Action: "heartbeat",
            Account: { Username: scwsUser }
        };
        scws.send(JSON.stringify(obj));
        setTimeout(this.scwsHeartbeat, 30000);
    }

    homeClicked = () => {
        this.props.history.push('./');
    }

    chatClicked = () => {
        this.props.history.push('./chat');
    }

    orderClicked = () => {
        this.props.history.push('./order');
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const menuText = this.props.menuText
        const { unreadChatCount } = this.props.chatStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <Row>
                                            <Col span={24} className='stm-footer'>
                                                <Row>
                                                    <Col
                                                        span={STAYCHAT_WS_URL ? 8 : 12}
                                                        className='stm-padding-2'
                                                        onClick={this.homeClicked}
                                                    >
                                                        <Row>
                                                            <Col
                                                                span={24}
                                                                className='stm-text-align-center stm-padding-top-4'
                                                            >
                                                                {
                                                                    menuText === 'home' ?
                                                                        <HomeIcon
                                                                            style={{
                                                                                color: activeTemplate.templateSetting.header.backgroundColor,
                                                                                fontSize: 24
                                                                            }}
                                                                        />
                                                                        :
                                                                        <HomeIcon
                                                                            style={{
                                                                                fontSize: 24
                                                                            }}
                                                                        />
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col
                                                                span={24}
                                                                className='stm-padding-bottom-4'
                                                                style={{
                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                    color: activeTemplate.templateSetting.text.color,
                                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize}px`
                                                                }}
                                                            >
                                                                <span>{webSettting.homeText}</span>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <>
                                                        {
                                                            STAYCHAT_WS_URL ?
                                                                <Col
                                                                    span={8}
                                                                    className='stm-text-align-center stm-padding-top-10'
                                                                    onClick={this.chatClicked}
                                                                >
                                                                    <Row>
                                                                        <Col span={24}>
                                                                            {
                                                                                menuText === 'chat'
                                                                                    ?
                                                                                    <ChatIcon
                                                                                        style={{
                                                                                            color: activeTemplate.templateSetting.header.backgroundColor,
                                                                                            fontSize: 20
                                                                                        }}
                                                                                    />
                                                                                    :
                                                                                    <Badge
                                                                                        count={unreadChatCount}
                                                                                        className='stm-badge-chat'
                                                                                    >
                                                                                        <ChatIcon
                                                                                            style={{
                                                                                                fontSize: 20
                                                                                            }}
                                                                                        />
                                                                                    </Badge>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col
                                                                            span={24}
                                                                            className='stm-padding-bottom-4'
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                color: activeTemplate.templateSetting.text.color,
                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize}px`
                                                                            }}
                                                                        >
                                                                            <span>{webSettting.chatText}</span>
                                                                        </Col>
                                                                    </Row>
                                                                </Col> :
                                                                null
                                                        }
                                                    </>
                                                    <Col
                                                        span={STAYCHAT_WS_URL ? 8 : 12}
                                                        className='stm-text-align-center stm-padding-top-4'
                                                        onClick={this.orderClicked}
                                                    >
                                                        <Row>
                                                            <Col span={24}>
                                                                {
                                                                    menuText === 'order' ?
                                                                        <OrderIcon
                                                                            style={{
                                                                                color: activeTemplate.templateSetting.header.backgroundColor,
                                                                                fontSize: 25
                                                                            }}
                                                                        />
                                                                        :
                                                                        <OrderIcon
                                                                            style={{
                                                                                fontSize: 25
                                                                            }}
                                                                        />
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Row>
                                                                <Col
                                                                    span={24}
                                                                    className='stm-padding-bottom-4'
                                                                    style={{
                                                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                        color: activeTemplate.templateSetting.text.color,
                                                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize}px`
                                                                    }}
                                                                >
                                                                    <span>{webSettting.orderText}</span>
                                                                </Col>
                                                            </Row>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(FooterMenu)